/**
 * Whether a failed request is news the reader needs told.
 *
 * The axios error interceptor in index.js drops a red banner over the corner of the window for every 400
 * and every 404 in the application, which is the right default: an operation the reader asked for and
 * that did not happen has to say so. But not every request is an operation. Some are asked on the
 * reader's behalf for something optional — the photograph of a tape being the case this was written for,
 * which the local stack has no endpoint for at all and which plenty of real media has never had taken —
 * and there the absence is already on the screen, drawn as 'no photograph of this tape'. A banner
 * quoting the upstream error on top of it tells the reader that something is broken when nothing is.
 *
 * So the flag is opt-out and lives on the request, exactly as `background` does for the loading wash
 * (see loadingWash.js): silence means the failure is worth reporting, and only a caller that has already
 * shown the reader what happened may say otherwise.
 *
 * Kept in its own module for the same reason the wash is: index.js mounts the application as it is
 * evaluated, so nothing there can be imported by a test.
 */

/**
 * @param {object} [config] - The axios request config a response or error arrived with.
 * @returns {boolean} Whether its failure should raise the global error banner.
 */
export const announcesItsFailures = (config) => !config?.quiet;
